// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"ff747657","227":"57fa79da","685":"0c974378"}[chunkId] + ".css";
};